import axiosConfig from "./axiosConfig";

const REPORTS_BASE = "/accounts/admin/moderation/reports";
const ACCOUNTS_BASE = "/accounts/admin/moderation/accounts";
const POSTS_BASE = "/accounts/admin/moderation/posts";

export const listReports = (params = {}) =>
  axiosConfig.get(`${REPORTS_BASE}/`, { params });

export const getReport = (id) =>
  axiosConfig.get(`${REPORTS_BASE}/${id}/`);

export const updateReport = (id, data) =>
  axiosConfig.patch(`${REPORTS_BASE}/${id}/`, data);

export const suspendAccount = (profileId, reason) =>
  axiosConfig.post(`${ACCOUNTS_BASE}/${profileId}/suspend/`, { reason });

export const unsuspendAccount = (profileId, data = {}) =>
  axiosConfig.post(`${ACCOUNTS_BASE}/${profileId}/unsuspend/`, data);

export const deleteAccount = (profileId, reason) =>
  axiosConfig.post(`${ACCOUNTS_BASE}/${profileId}/delete/`, { reason });

export const listModerationPosts = (params = {}) =>
  axiosConfig.get(`${POSTS_BASE}/`, { params });

export const moderatePost = (postId, action, note = "") =>
  axiosConfig.post(`${POSTS_BASE}/${postId}/action/`, { action, note });

export const getPostDetail = (postId) =>
  axiosConfig.get(`/accounts/model-images/${postId}/`);
